module.exports = __webpack_public_path__ + "static/media/nineteenth_robert_n_stewart_bridge1.ad78cc56.jpg";